DialogAddEntUniGesCtrl.$inject = ['$log', '$scope', '$http'];
export default function DialogAddEntUniGesCtrl($log, $scope, $http) {
    const URL_MANT_UNI_GES = Sigo.var.path + '/mantenimiento/unidad-gestion-acciones';

    var vm = this;

    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;
    vm.cargando = {
        datos: true,
        submit: false
    };
    vm.formDeshabilitado = true;
    var idUniGes = vm.model.idUniGes;

    cargarEntidades();

    function cargarEntidades() {
        var url = URL_MANT_UNI_GES + '/add-entidad/' + idUniGes;
        var promise = $http.get(url);
        promise.then(function (data) {
            vm.entidades = data.data.entidades;
            vm.cargando.datos = false;
            vm.formDeshabilitado = false;

            if (vm.entidades.length < 1) {
                vm.dialogHandler.cancel();
                $.toast({
                    heading: 'Advertencia',
                    text: "Ya se han añadido todas las entidades",
                    showHideTransition: 'slide',
                    icon: 'warning'
                });
            }
        });
    }

    vm.submitEntidad = submitEntidad;

    function submitEntidad(entidadSeleccionada) {
        vm.cargando.submit = true;
        vm.formDeshabilitado = true;

        var entId = null;
        if (typeof entidadSeleccionada.id !== 'undefined') entId = entidadSeleccionada.id;

        var url = URL_MANT_UNI_GES + '/add-entidad/' + idUniGes + '/' + entId;
        var promise = $http.post(url);

        promise.then(function (data) {
            $.toast({
                heading: 'Añadida',
                text: 'Entidad añadida',
                showHideTransition: 'slide',
                icon: 'success'
            });

            vm.dialogHandler.close(data);
            //TODO: COntrolar errores
        }, function () {
            $.toast({
                heading: 'Error',
                text: Lang.get('mensajes.error_mensaje'),
                showHideTransition: 'slide',
                icon: 'error'
            });

        });
    }

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    }
}